import BigNumber from 'bignumber.js';
import { isAddress } from 'web3-utils';

import { parseFormattedIntValue } from './parseFormattedIntValue';

const MAX_UNIT256 = new BigNumber(
  115792089237316195423570985008687907853269984665640564039457584007913129639936,
);
export function getValidateInputType(type: string): (value: string) => boolean {
  const lowerCaseType = type.toLowerCase();

  if (lowerCaseType.indexOf('[]') > -1) {
    return value => {
      try {
        const jsonValue = JSON.parse(value);
        if (!Array.isArray(jsonValue)) {
          return false;
        }

        const singleType = lowerCaseType.replace('[]', '');
        return jsonValue.every(value =>
          getValidateInputType(singleType)(value),
        );
      } catch {
        return false;
      }
    };
  }

  if (lowerCaseType.indexOf('address') > -1) {
    return value => isAddress(value);
  }

  if (lowerCaseType.indexOf('int') > -1) {
    return value => {
      const parsedValue = new BigNumber(parseFormattedIntValue(value));
      if (!parsedValue.isInteger()) {
        return false;
      }

      return parsedValue.isLessThanOrEqualTo(MAX_UNIT256);
    };
  }

  return () => true;
}
